import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { PaymentDistributionCard } from '@/features/jobs/details/components/PaymentDistributionCard'

export interface PaymentDistributionCardContainerProps {
  vm: JobDetailsViewModel
}

export const PaymentDistributionCardContainer = observer(
  function PaymentDistributionCardContainer({
    vm,
  }: PaymentDistributionCardContainerProps) {
    return (
      <PaymentDistributionCard
        primaryAmount={vm.job.primaryAmount}
        canViewCoupon={vm.billingVm.canViewCoupon}
        couponDisplay={vm.billingVm.couponDisplay}
        couponCode={vm.billingVm.coupon?.code}
        canRemoveCoupon={vm.billingVm.canRemoveCouponAsAdmin}
        onRemoveCoupon={vm.billingVm.removeCouponAsAdminVm.show}
        canViewProCut={vm.canViewProCut}
        providerCutAmount={vm.job.providerCutAmount}
        canSplitPayout={vm.billingVm.canSplitPayout}
        onEditSplit={vm.billingVm.splitPayoutDialogVm.show}
        total={vm.job.total}
        paidAmount={vm.job.paidAmount}
        receipts={vm.billingVm.jobPurchaseTransactions.map((t) => ({
          id: t.id,
          receiptUrl: t.receiptUrl ?? '',
          amount: t.amount,
          dateCreated: t.dateCreated,
        }))}
        refundedAmount={vm.billingVm.jobRefundTransactionAmount}
      />
    )
  },
)
